import React from 'react';
import "./App.css";
import Header from './Components/header/Header';
import Navbar from './Components/navbar/Navbar';
import Home from './Components/home/Home';
import About from './Components/about/About';
import Skills from './Components/skills/Skills';
import Services from './Components/services/Services';
import Qualification from './Components/qualification/Qualification';
import Testimonials from './Components/testimonials/Testimonials';
import Contact from './Components/contact/Contact';
import ScrollUp from './Components/scrollup/ScrollUp';
import Work from './Components/work/Work';
import Footer from './Components/footer/Footer';
import { motion, useScroll } from "framer-motion";

const App = () => {
  const { scrollYProgress } = useScroll();

  return (
    <>
      <motion.div
        className="progress__bar"
        style={{ scaleX: scrollYProgress }}
      />
      
      <Header />
      
      <main className='main'>
        <Home />
        <About />
        <Skills />
        <Services />
        <Qualification />
        <Work />
        <Testimonials />
        <Contact />
      </main>
      
        <Footer />
        <ScrollUp />
    </>
  )
}

export default App